import { create } from 'zustand';

export interface ShownError {
  message: string;
  correlationId?: string;
}

interface ErrorState {
  error: ShownError | null;
  show: (e: ShownError) => void;
  dismiss: () => void;
}

/** The global error banner (the default for failed queries / mutations). */
export const useErrorStore = create<ErrorState>((set) => ({
  error: null,
  show: (error) => set({ error }),
  dismiss: () => set({ error: null }),
}));
